import { CloseCircleTwoTone } from '@ant-design/icons';
import React from 'react';

type Props = {
    twoToneColor?: string;
};

const CcxIconCloseCircleTwoTone = ({ twoToneColor }: Props) => {
    return (
        <CloseCircleTwoTone
            data-testid="CcxIconCloseCircleTwoTone"
            twoToneColor={twoToneColor}
        />
    );
};

export default CcxIconCloseCircleTwoTone;
